export const Search = (props) => {
  const { size = 28, onClick, verticalAlign, marginLeft, marginRight, top, color, className = ''} = props;
  return (
    <span onClick={onClick} className={`icon-wrap ${className}`} style={{ marginLeft, marginRight, top, color }}>
      <svg style={{ verticalAlign }} width={size} height={size} xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 28 28'>
        <path
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
          d='M24.5 24.5l-5.075-5.075m2.742-6.592a9.333 9.333 0 11-18.667 0 9.333 9.333 0 0118.667 0z'
        ></path>
      </svg>
    </span>
  );
};
